import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  initToken: ['data'],
  initFinish: ['data'],
})

export const StartupTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  token: null,
  initFinish: false,
})

/* ------------- Selectors ------------- */

export const StartupSelectors = {
  token: state => state.startup,
  initFinish: state => state.initFinish,
}

/* ------------- Reducers ------------- */

export const initToken = (state, { data }) => {
  return state.merge({ ...state, token: { ...state.token, fetching: true, data } })
}

export const initFinish = (state, { data }) => {
  return state.merge({ ...state, initFinish: true, })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.INIT_TOKEN]: initToken,
  [Types.INIT_FINISH]: initFinish,
})
